import { useTranslation } from "react-i18next";
import Slider from "react-slick";


const Banner = () => {
  const { t } = useTranslation();

  const slideSlick = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    fade: true,
    easing: "fade",
    adaptiveHeight: true
  };

  const SlideList = [
    {
      textPosition: 'text-center',
      bgImage: 'sliderBg--1',
      category: '',
      title: t('banner.firstSlideTitle'),
      description: t('banner.firstSlideDescription'),
      buttonText: t('header.contact'),
      buttonLink: '#contact'
    },
    {
      textPosition: 'text-center',
      bgImage: 'sliderBg--2',
      category: '',
      title:  t('banner.secondSlideTitle'),
      description: t('banner.secondSlideDescription'),
      buttonText: t('header.contact'),
      buttonLink: '#contact'
    },
    {
      textPosition: 'text-center',
      bgImage: 'sliderBg--3',
      category: '',
      title:   t('banner.thirdSlideTitle'),
      description: t('banner.thirdSlideDescription'),
      buttonText: t('header.contact'),
      buttonLink: '#contact'
    }
  ]

  return (
    <div id="home">
      <div className="slider-wrapper">
        <div className="slider-activation slider-startup">
          <Slider className="rn-slick-dot dot-light" {...slideSlick}>
            {SlideList.map((value , index) => (
                // Start Single Slider
                <div className={`slide fullscreen d-flex align-items-center background-size-cover justify-content-center bg_image ${value.bgImage}`} key={index} data-black-overlay="8">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className={`inner ${value.textPosition}`}>
                          {value.category ? <span>{value.category}</span> : ''}
                          {value.title ? <h1 className="title theme-gradient">{value.title}</h1> : ''}
                          {value.description ? <p className="description">{value.description}</p> : ''}
                          {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                // End Single Slider
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}


export default Banner;
